import { Component, OnInit, ViewChild } from '@angular/core';
import { flyInOut, fadeIn, fade, zFade, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle,viewInfo,viewDesc } from '../animations';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectComponent } from 'ng-select';
import { Observable } from 'rxjs/Rx';

import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';

import { Product } from '../../models/product';
import { Category } from '../../models/category';
import { Account } from '../../models/account';
import { Item } from '../../models/item';

declare var $: any;

@Component({
  selector: 'store-customize',
  templateUrl: './customize.component.html',
  animations: [flyInOut, fadeIn, fade, zFade, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle,viewInfo,viewDesc]
})
export class CustomizeComponent implements OnInit {
	
	accounts: Account;
	products: Product;
	cartItems: Product;
	allproducts: Product;
	categories: Category;
	groups: Category;
	items: Item;

	title: any;
	header: any;
	subtitle: any;
	headerHeight: any;
	headerAlign: any;

	total: any;
	selected: any;
	cart: any[];
	custom: any[];
	flashCart: boolean;
	expandSelection: boolean;

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router) { }



	addItem(item) {
		this.storeService.addItem(item.id);
		this.refreshCustomizer();
	}

	subtractItem(item) {
		this.storeService.removeItem(item.id);
		this.refreshCustomizer();
	}

	toggleItem(item) {

		if ( this.isSelected(item) ) {
			this.subtractItem(item);
		} else {
			this.addItem(item);
		}

	}

	isSelected(item) {
		let found = false;
		for (var i = this.selected.length - 1; i >= 0; i--) {
			if (this.selected[i].id == item.id) 
				found = true;
		}

		return found;
	}

	refreshCustomizer() {
		this.cart = this.storeService.getCartContents();
		this.custom = this.storeService.getCustomizerContents();

		Promise.resolve( this.storeService.getItems(this.custom) ).then((cartdata) => {
			this.selected = cartdata
		});

		this.getTotal();
	}

	getTotal() {
		Promise.resolve(this.storeService.getCustomizerTotal()).then(t => 
			this.total = t
		);
	}

	expandSidebar(e?) {
		this.expandSelection = this.expandSelection ? true : false;
	}


	ngOnInit() {
		
		this.title = 'CUSTOM IDENTITY';
		this.headerHeight = '398px';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-faq.jpg")' );
		this.subtitle = 'Create your own identity';


		this.refreshCustomizer();

		$(document).scroll(function(e) {
			let top = $(document).scrollTop();
			$('#Sidebar').css('top', +(top+30)+'px')
		})

		/* 
		* User Authentication System
		*/

		this.userService.authorizeUser().subscribe(user => 
			this.accounts = user
		);

		Promise.resolve(this.storeService.getItems('all')).then((items) => {
			this.items = items;
		});

		Promise.resolve(this.storeService.getCategories()).then((categories) => {
			this.categories = categories;
		});

		Promise.resolve(this.storeService.getGroups()).then((groups) => {
			this.groups = groups;
		});
	}

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/customize/customize.component.ts